import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Modal, Spinner } from "react-bootstrap";
import { checkCardanoSignInMethods } from "./utils";
import AV from "../../av-package";
import { AppContext } from "./connectors";
import { createToUserProfile } from "../../actions/DataActions";
import "./Modal.css";

const WalletCardanoModal = ({ modalVisibility, closeModal }) => {
  const {
    cardanoAddress: wallet,
    setCardanoAddress,
    setCardanoWallet,
    setCardnaoAuthToken,
    values,
  } = useContext(AppContext);

  const [state, setState] = useState({
    address: null,
    connecting: false,
  });

  const checkWallet = async (wallet) => {
    setState((state) => ({
      ...state,
      connecting: true,
    }));
    try {
      await AV.connect(wallet)
        .then(async (connected) => {
          if (connected) {
            let walletAddress = await AV.getConnectedWalletAddress();

            setCardanoAddress(walletAddress);
            setCardanoWallet(wallet);

            checkCardanoSignInMethods(walletAddress, {
              onError: (err) => {
                toast.error(err);
                handleDisconnectWallet();
                setState((state) => ({
                  ...state,
                  connecting: false,
                }));
              },
              sucssess: (user) => {
                createToUserProfile(user, walletAddress);
                setCardnaoAuthToken(user?.accessToken);
                setState((state) => ({
                  ...state,
                  connecting: false,
                }));
                closeModal();
              },
            });
          } else {
            setState((state) => ({
              ...state,
              isShowFaliure: true,
              connecting: false,
            }));
            toast.error("User declined to sign", {
              theme: "colored",
              autoClose: 5000,
            });
          }
        })
        .catch((error) => {
          setState((state) => ({
            ...state,
            connecting: false,
          }));

          toast.error(error.message, { theme: "colored", autoClose: 5000 });
        });
    } catch (error) {
      setState((state) => ({
        ...state,
        connecting: false,
      }));
      toast.error("Error while connecting wallet", {
        theme: "colored",
        autoClose: 5000,
      });
    }
  };

  const handleDisconnectWallet = () => {
    setCardanoAddress(null);
    setCardanoWallet(null);
    closeModal();
  };

  const getWallets = () => {
    let extensions = [];
    let extNames = AV.getExtensionsNames();
    let ids = AV.getExtensionsIds();
    ids?.map((id, index) => {
      // if (id !== "eternl")
      extensions.push({ id: id, name: extNames[index] });
    });
    (async (extensions) => {
      try {
        let insaltedExts = await AV.getAvailableExtensions();

        if (insaltedExts) {
          extensions?.map((item) => {
            if (insaltedExts.includes(item.id)) {
              item.installed = true;
            }
          });
        }

        setState((state) => ({
          ...state,
          extensions,
        }));
      } catch (ex) {
        setState((state) => ({
          ...state,
          extensions,
        }));
      }
    })(extensions);
  };

  useEffect(() => {
    getWallets();
  }, []);

  let connectModalJSX = () => {
    return (
      <div>
        {/* {state.connecting && (
          <div className="generalLoader ">
            <Spinner size="lg" variant="border" />
          </div>
        )} */}

        <div className="modal-caption text-center">
          <h3 className="title title-sm">Choose your wallet</h3>
          <p>Please select your wallet from the following list!</p>

          <ul className="wallet-list">
            {state.extensions?.map((extension, index) => (
              <li
                key={extension.id}
                className={`list-item ${
                  extension.installed ? "active" : "nonactive pe-none"
                }`}
                value={extension.id}
                onClick={() => {
                  checkWallet(extension.id);
                }}
              >
                <label>{extension.name}</label>
                <span>
                  {extension.installed ? (
                    <i className="success">Installed</i>
                  ) : (
                    <i className="error">Not Installed</i>
                  )}
                </span>
              </li>
            ))}
            {state.connecting && <Spinner size="lg" variant="border" />}
          </ul>
        </div>
        <div className="mobile-btn">
          <button onClick={closeModal} className="custom-btn gray-bg lg">
            Close
          </button>
        </div>
      </div>
    );
  };
  let disconnectModalJSX = () => {
    return (
      <>
        <div className="modal-caption text-center">
          <h3 className="title title-sm">Disconnect Wallet?</h3>
          <p>
            Don’t worry. Disconnecting wallet won’t affect your in progress
            transactions!
          </p>
        </div>
        <div className="button-groups">
          <button
            className="custom-btn lg accent-bg"
            onClick={handleDisconnectWallet}
          >
            Yes
          </button>
          <button className="custom-btn lg gray-bg" onClick={closeModal}>
            No
          </button>
        </div>
      </>
    );
  };
  return (
    <Modal
      show={modalVisibility}
      size="sm"
      // onAfterOpen={afterOpenModal}
      // onRequestClose={closeModal}
      dialogClassName="modal-dialog modal-dialog-centered"
      contentClassName={"customPopup cardWallet"}
    >
      <button type="button" className="close" onClick={closeModal}>
        {/* <img src={close} alt="close" /> */}
      </button>
      <div className="content">
        {wallet && !state.connecting ? disconnectModalJSX() : connectModalJSX()}
      </div>
    </Modal>
  );
};

export default WalletCardanoModal;
